<template>
  <div
    :class="{
      'text-black': active,
      'text-grey': !active,
    }"
    class="leading-normal flex py-4 cursor-pointer items-baseline"
  >
    <div class="mr-2 flex items-center">
      <div
        :class="{
          'border-orange-light': active,
          'border-grey-dark': !active,
        }"
        class="custom-radio rounded-full border h-custom flex items-center justify-center"
      >
        <div
          v-if="active"
          class="bg-orange h-3 w-3 rounded-full"
        />
      </div>
    </div>
    <div class="flex items-center"><slot /></div>
  </div>
</template>

<script>
export default {
  name: 'BaseRadioButton',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-radio {
  height: 21px;
  width: 18px;
}
.h-custom {
  height: 18px;
  width: 18px;
}
</style>
